module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9MdIh"))).then(() => parcelRequire('hEqeo'));